<script setup lang="ts">
import type { FaqData } from '~/utils/crystallize/pieces'

defineProps<{
  title: FaqData['title']
  description: FaqData['description']
  questions: FaqData['questions']
  aside: FaqData['aside']
}>()

// Shared between the two sections
const px = 'px-l md:px-2xl lg:px-4xl'
</script>

<template>
  <section class="gap-y-[--gutter] grid grid-cols-subgrid">
    <StickyContent
      is="aside"
      v-if="aside"
      class="bg-blurple-50 py-l md:py-xl lg:py-2xl rounded-4xl col-span-full lg:col-span-3 2xl:col-span-5 h-fit [&_h2]:title-m flex flex-col gap-s static lg:sticky"
      :class="px"
    >
      <CrystallizeRichText v-for="(b, k) in aside" :key="k" :block="b" />
    </StickyContent>
    <section
      v-if="questions?.items?.length"
      class="py-xl md:py-2xl lg:py-3xl flex flex-col gap-s bg-blurple-50 rounded-4xl col-span-full"
      :class="[
        px,
        {
          'lg:col-span-5 2xl:col-span-7': !!aside,
        },
      ]"
    >
      <h2 v-if="title" class="mb-3xs title-l" v-text="title" />

      <CrystallizeRichText v-for="(block, i) in description" :key="i" :block="block" />

      <NettbutikkArticleAccordionItem
        v-for="item in questions.items"
        :key="item.summary"
        :item="item"
        name="faq"
        class="bg-blurple-100 rounded-2xl"
      />
    </section>
  </section>
</template>
